import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/agent/page.tsx");
